module.exports = __webpack_public_path__ + "media/images/aloe/logo/nephos-yellow-0cc4c32ed244d46e68d901b9a22ea37b.svg";